const prefix = 'bootstrap2';

function fullKey(key) {
  return `${prefix}:${key}`;
}

export function get(key) {
  const value = localStorage.getItem(fullKey(key));
  return value ? JSON.parse(value) : {};
}

export function patch(key, value = {}) {
  localStorage.setItem(fullKey(key), JSON.stringify(Object.assign(get(key), value)));
}
